import * as React from 'react'

import { Button, Space } from '@ally/metronome-ui'
import { AddAutoAccountSuccessProps } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { AccountDetails, StyledTextBody } from '../Shared'

const AddAutoAccountSuccessContent: React.FC<AddAutoAccountSuccessProps> = ({
  onComplete,
  status,
  username,
  userData,
  error,
}) => {
  const textBody = userData
    ? "You're all set to manage your new account online with the username shown here."
    : "You're all set to manage your new account online with the username shown here. Visit your Profile and Settings to make sure your account info and preferences are up to date."

  return (
    <>
      <LoginHeading title="We added your new account." />

      <Space mb="lg">
        <StyledTextBody size="sm" tag="p">
          {textBody}
        </StyledTextBody>
      </Space>

      <AccountDetails
        username={username}
        userData={userData}
        shouldShowAdditionalCopy
      />

      <Button
        allytmln="Go to Snapshot"
        loading={status === 'Loading'}
        onClick={onComplete}
        text="Go to Snapshot"
        type="submit"
        variant="primary"
      />
    </>
  )
}

export const AddAutoAccountSuccess: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AddAutoAccountSuccess') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <AddAutoAccountSuccessContent {...activeScreen.payload} />
}
